/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    TibboDataType,
    BlockType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    const name = feature.getSettingValue('SETTINGID');
    const dataType = feature.getSettingValue('DATATYPE');
    let DEFAULT = feature.getSettingValue('DEFAULT');
    let min = feature.getSettingValue('MIN');
    if (min === '') min = feature.getDefault('MIN');
    let max = feature.getSettingValue('MAX');
    if (max === '') max = feature.getDefault('MAX');
    const project: ProjectConfiguration = feature.project;
    const SETTINGTYPE = feature.getSettingValue('SETTINGTYPE');
    const init = feature.getSettingValue('INITIALIZE');
    const comment = feature.getSettingValue('NAME');

    if (SETTINGTYPE === 'string') {
        DEFAULT = `"${DEFAULT}"`;
    }

    if (DEFAULT === '') {
        DEFAULT = '0';
    }

    let setCode = `
settings_save_one("app/${name}", &${name}, sizeof(${name}));
            `;
    let readCode = `
if (len != sizeof(${name})) {
    return -EINVAL;
}
rc = read_cb(cb_arg, &${name}, sizeof(${name}));
if (rc >= 0) {
    return 0;
}
            `;
    if (SETTINGTYPE === 'string') {
        // strings
        readCode = `
rc = read_cb(cb_arg, &buf, len);
if (rc >= 0)
{
    ${name} = buf;
    return 0;
}
                `;

        setCode = `
snprintk(buf, sizeof(buf), "%s", value.c_str());
rc = settings_save_one("app/${name}", &buf, strlen(buf)+1);
                `;
    }
    blocks.push({
        location: 'app_settings_set',
        blockType: BlockType.CODE,
        template: `
if (strcmp(name, "${name}") == 0) {               
    ${readCode}

    return rc;
}
            `,
    });

    blocks.push({
        location: 'stg_set',
        blockType: BlockType.CODE,
        template: `
if (strcmp(name.c_str(), "${name}") == 0) {
    ${setCode}
}
                `,
    });


    return blocks;
};
